"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const houston_styles_1 = tslib_1.__importStar(require("@eduzz/houston-styles"));
const Spinner_1 = tslib_1.__importDefault(require("../Spinner"));
const getColorFallback_1 = tslib_1.__importDefault(require("../utils/getColorFallback"));
const Button = props => {
    const { children, disabled = false, startIcon, endIcon, variant, loading = false, loadingText, className, fullWidth } = props, rest = tslib_1.__rest(props, ["children", "disabled", "startIcon", "endIcon", "variant", "loading", "loadingText", "className", "fullWidth"]);
    return ((0, jsx_runtime_1.jsxs)("button", Object.assign({ className: (0, houston_styles_1.cx)(className, `--${variant !== null && variant !== void 0 ? variant : 'contained'}`, { '--fullWidth': fullWidth }) }, rest, { disabled: disabled || loading }, { children: [!!startIcon && !loading && (0, jsx_runtime_1.jsx)("span", Object.assign({ className: '__startIcon' }, { children: startIcon })), !loading && (0, jsx_runtime_1.jsx)("span", Object.assign({ className: '__text' }, { children: children })), loading && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Spinner_1.default, { size: 15, color: 'inherit', className: '__loader' }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: '__text' }, { children: loadingText !== null && loadingText !== void 0 ? loadingText : children }))] })), !!endIcon && (0, jsx_runtime_1.jsx)("span", Object.assign({ className: '__endIcon' }, { children: endIcon }))] })));
};
exports.default = (0, houston_styles_1.default)(Button, { label: 'houston-button' })(({ theme, color: colorProp }) => {
    const color = (0, getColorFallback_1.default)(theme, colorProp);
    return (0, houston_styles_1.css) `
    border: none;
    cursor: pointer;
    text-transform: none;
    padding: 10px 16px;
    height: 40px;
    border-radius: ${theme.border.radius.xs};
    font-weight: ${theme.font.weight.bold};
    font-family: ${theme.font.family.base};
    line-height: ${theme.line.height.default};
    font-size: ${theme.font.size.xxs};
    position: relative;
    transition: 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;

    &.--fullWidth {
      width: 100%;
    }

    &.--contained {
      background-color: ${color.pure};
      color: white;

      &:hover:not(:disabled) {
        background-color: ${color.light};
      }

      &:active:not(:disabled) {
        background-color: ${color.dark};
      }

      &:disabled {
        background-color: ${theme.neutralColor.high.medium};
      }
    }

    &.--outlined {
      background-color: transparent;
      color: ${color.pure};
      border: 1px solid;
      border-color: ${color.light};

      &:hover:not(:disabled),
      &:active:not(:disabled) {
        border-color: ${color.dark};
        color: ${color.dark};
      }
    }

    &.--text {
      background-color: transparent;
      color: ${color.pure};

      &:hover:not(:disabled),
      &:active:not(:disabled) {
        background-color: ${theme.neutralColor.high.light};
      }
    }

    &:disabled {
      cursor: default;
      color: ${theme.hexToRgba(theme.neutralColor.low.pure, theme.opacity.level[6])};
      border-color: ${theme.neutralColor.high.medium};
    }

    &:before {
      content: ' ';
      position: absolute;
      left: -4px;
      right: -4px;
      top: -4px;
      bottom: -4px;
      border: 2px solid transparent;
      transition: 0.3s;
      border-radius: ${theme.border.radius.sm};
    }

    &:focus:not(:active):not(:hover):before {
      border-color: ${theme.neutralColor.high.medium};
    }

    & > .__loader {
      margin-right: ${theme.spacing.nano};
    }

    & > .__startIcon {
      margin-right: ${theme.spacing.nano};
    }

    & > .__endIcon {
      margin-left: ${theme.spacing.nano};
    }

    & > .__startIcon > svg,
    & > .__endIcon > svg {
      vertical-align: middle;
      font-size: 17px;
    }
  `;
});
